import * as React from 'react';
import { render } from 'react-dom';
import { Workspace } from './Workspace';

export function renderWorkspace() {
	render(<Workspace />, document.getElementById('applicationHost'));
}
